import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import bannerImage from '../../assets/bannerImage01.jpeg';
import styles from './CompanyInfo.module.scss';
import { useTranslation } from 'react-i18next';
function CompanyInfo() {
  const { t, i18n } = useTranslation();
  return (
    <div>
      <Header />
      <div className={styles.contentWrap}>
        <img src={bannerImage} alt="image" />
        <div className={styles.textWrap}>
          <h3 dangerouslySetInnerHTML={{ __html: t('home.56') }}></h3>
          <p dangerouslySetInnerHTML={{ __html: t('home.57') }}></p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default CompanyInfo;
